// extracted by mini-css-extract-plugin
export default {"field":"Field_field__zhyRY","label":"Field_label__puXGH"};